import React, { FunctionComponent } from "react";
import styled from "styled-components";
import Image from "next/image";

import { uuid } from "utils";
import StepForwardCarousel from "./Carousel2025";

type FullImageCarouselContentProps = {
  images: {
    imageSrc: string;
    alt: string;
  }[];
};

const FullImageCarouselContent: FunctionComponent<
  FullImageCarouselContentProps
> = (props) => {
  return (
    <S.Section>
      <StepForwardCarousel hasLeftButton>
        {props.images.map((slide) => (
          <S.Slide key={uuid()}>
            <Image
              src={slide.imageSrc}
              alt={slide.alt}
              layout="fill"
              objectFit="cover"
            />
          </S.Slide>
        ))}
      </StepForwardCarousel>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  aspect-ratio: 2.5/1;

  @supports not (aspect-ratio: 2/1) {
    &::before {
      float: left;
      padding-top: 50%;
      content: "";
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }
`;

S.Slide = styled.li`
  position: relative;
  width: 100%;
  height: 100%;
`;

export default FullImageCarouselContent;
